import * as React       from "react";

import "./prod-file-download.scss";

import {cst, cstAssign} from "@Common/react/chain-services";
import {UseState}       from "@Common/react/use-state";
import {Types}          from "@Common/types";

import {downloadProds} from "../../common/download-prods";
import {Button}        from "../button/button";

export const ProdFileDownload = ({
/*  PROPS  ************************************************************************************************************/
    highResProducts,
    sides,
    changed,
    disableSaves,
    itemId,
    loadProdFiles,
}:{
/*  PROP TYPES  *******************************************************************************************************/
    highResProducts      : any, // TODO: Find actual type
    sides                : any, // TODO: Find actual type
    changed              : boolean,
    disableSaves         : any,
    itemId               : string,
    loadProdFiles        : () => any,
}) => cst<{
/*  CS ASSIGNMENT NODE TYPES  *****************************************************************************************/
    state                : Types.Common.React.UseState.UseStateNext<{
        downloadPercent  : number,
    }>,
    onDownloadProgress   : (progressPercent:number) => void,
}>(

    // set state vars
    cstAssign("state", (_, next) => UseState({
        defaultValue: {
            downloadPercent: 0,
        },
        next,
    })),

    // set download progress event handler
    cstAssign("onDownloadProgress", ({state}, next) => next((progressPercent) => {
        state.onChange({...state.value, downloadPercent: progressPercent});
    })),

    // render component
    ({state, onDownloadProgress}) => (
        <div className="prod-file-download-d2w">
            <Button
                buttonText="Download Prods"
                xdQaName="Download Prods"
                disabled={disableSaves.value}
                downloadProgressPercent={state.value.downloadPercent}
                onClick={async () => {
                    disableSaves.onChange(true);
                    const highResProducts1 = (changed || !highResProducts || !Array.isArray(highResProducts?.pdf) ) ? (
                        await loadProdFiles()
                    ) : (
                        highResProducts
                    );
                    if (highResProducts1) {
                        await downloadProds(highResProducts1.combinedPdf ?? highResProducts1.pdf, itemId, sides, onDownloadProgress)
                    }

                    // remove download percent after another second to ensure that 100% status is displayed to the user
                    await setTimeout(() => state.onChange({...state.value, downloadPercent: 0}), 1000);
                    disableSaves.onChange(false);
                }}
            />
        </div>
    )
);
